// import { EuiLink } from "@elastic/eui";
// import {
//   ActionIcon,
//   Button,
//   Card,
//   Group,
//   Stack,
//   TextInput,
//   Title,
//   Tooltip,
//   Box,
//   Badge,
// } from "@mantine/core";
// import { modals } from "@mantine/modals";
// import { IconEdit, IconSearch, IconTrash } from "@tabler/icons-react";
// import {
//   MantineReactTable,
//   MRT_ColumnDef,
//   MRT_ColumnFiltersState,
//   MRT_PaginationState,
//   MRT_RowSelectionState,
//   MRT_SortingState,
//   useMantineReactTable,
// } from "mantine-react-table";
// import React, { useEffect, useState } from "react";
// import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
// import {
//   isNullOrEmpty,
//   isNullOrUndefined,
//   isNullOrUndefinedArry,
// } from "../../../_base/extension/StringExtension";
// import Repository from "../../../_base/helper/HttpHelper";
// import { ParamSearchBase } from "../../../_base/model/_base/ParamSearchBase";
// import AppAction from "../../../common/AppAction";
// import { _localization } from "../../../config/location";
// import { API_ROUTE } from "../../../const/apiRoute";
// import { MessageResponse } from "../../../model/MessageResponse";
// import CreateView from "./CreateView";
// import DeleteView from "./DeleteView";
// import EditView from "./EditView";

// const UrlRedirect = () => {
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState<string | undefined>();
//   const [pagination, setPagination] = useState<MRT_PaginationState>({
//     pageIndex: 0,
//     pageSize: 20,
//   });
//   const [paramSearch, setParamSearch] = useState<ParamSearchBase>();
//   const [isSelectedItem, setSelectedItems] = useState<any[]>([]);
//   const [toltal, setTotal] = useState(0);
//   const [deleteViewStatus, setDeleteViewStatus] = useState(0);
//   const [height, setHeight] = useState(0);
//   const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
//   const [rowCount, setRowCount] = useState(0);
//   const [sorting, setSorting] = useState<MRT_SortingState>([]);
//   const [globalFilter, setGlobalFilter] = useState("");
//   const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
//     []
//   );
//   const [isLoading, setIsLoading] = useState(false);
//   const [isRefetching, setIsRefetching] = useState(false);
//   const headerRef = React.useRef<HTMLDivElement>(null);
//   const hacomUrl = process.env.REACT_APP_BASE_WEB_HACOM_URL;
//   const sizeGrid = { base: 6, sm: 4, md: 3, lg: 3, xl: 2 };

//   const handleDeleteViewClose = (status: number) => {
//     setDeleteViewStatus(status);
//   };
//   const [data, setdata] = useState<any[]>([]);

//   const columns = React.useMemo<MRT_ColumnDef<any>[]>(
//     () => [
//       {
//         accessorKey: "STT",
//         header: "STT",
//         size: 80,
//         enableColumnFilter: false,
//         enableSorting: false,
//         Cell: ({ row }) => <>{row.index + 1}</>,
//       },
//       {
//         accessorKey: "oldUrl",
//         header: "Link truy cập",
//         size: 400,
//         Cell: ({ renderedCellValue }) => (
//           <Box
//             style={{
//               fontFamily: "monospace",
//               fontSize: "13px",
//               color: "#2563eb",
//             }}
//           >
//             {renderedCellValue}
//           </Box>
//         ),
//       },
//       {
//         header: "Xem tại web",
//         size: 150,
//         Cell: ({ renderedCellValue, row }) => (
//           <EuiLink
//             target="_blank"
//             href={`${hacomUrl}/${row.original.oldUrl}`}
//             style={{
//               fontWeight: 500,
//               color: "#059669",
//               textDecoration: "none",
//             }}
//           >
//             <Badge color="green" variant="light" radius="md">
//               Xem web
//             </Badge>
//           </EuiLink>
//         ),
//       },
//       {
//         accessorKey: "newUrl",
//         header: "Link đích",
//         size: 400,
//         Cell: ({ renderedCellValue, row }) => (
//           <Box
//             style={{
//               fontFamily: "monospace",
//               fontSize: "13px",
//               color: "#7c3aed",
//             }}
//           >
//             {renderedCellValue}
//           </Box>
//         ),
//       },
//       {
//         accessorKey: "redirectCode",
//         header: "Redirect code",
//         Cell: ({ renderedCellValue, row }) => (
//           <Badge
//             color={
//               renderedCellValue === "301"
//                 ? "blue"
//                 : renderedCellValue === "302"
//                 ? "orange"
//                 : "gray"
//             }
//             variant="filled"
//             radius="md"
//             size="md"
//           >
//             {renderedCellValue}
//           </Badge>
//         ),
//       },
//       {
//         accessorKey: "action",
//         header: "Thao tác",
//         size: 120,
//         Cell: ({ renderedCellValue, row }) => (
//           <Group gap="xs" justify="center">
//             <Tooltip label="Chỉnh sửa" position="top">
//               <ActionIcon
//                 variant="light"
//                 color="blue"
//                 size="md"
//                 radius="md"
//                 onClick={(e: any) => {
//                   editItem(row.original.id);
//                 }}
//               >
//                 <IconEdit size={16} />
//               </ActionIcon>
//             </Tooltip>{" "}
//             <Tooltip label="Xóa" position="top">
//               <ActionIcon
//                 variant="light"
//                 color="red"
//                 size="md"
//                 radius="md"
//                 onClick={(e: any) => {
//                   deleteItem([row.original.id]);
//                 }}
//               >
//                 <IconTrash size={16} />
//               </ActionIcon>
//             </Tooltip>
//           </Group>
//         ),
//       },
//     ],
//     []
//   );
//   const table = useMantineReactTable({
//     columns,
//     data: data || [],
//     enableColumnResizing: true,
//     enableTopToolbar: false,
//     mantineTopToolbarProps: {
//       style: {
//         borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
//         marginBottom: 5,
//       },
//     },
//     localization: _localization,

//     initialState: {
//       showColumnFilters: false,
//       columnPinning: {
//         right: ["action"],
//       },
//       density: "md",
//     },
//     enableExpanding: false,
//     enableExpandAll: false,
//     paginateExpandedRows: false,
//     enableStickyFooter: true,
//     enableRowSelection: true,
//     enableToolbarInternalActions: false,
//     mantineTableContainerProps: {
//       style: {
//         maxHeight: height,
//         minHeight: height,
//         borderRadius: "12px",
//         border: "1px solid #e9ecef",
//       },
//     },
//     enableStickyHeader: true,
//     onRowSelectionChange: setRowSelection,
//     enableColumnFilters: true,
//     enableSorting: true,
//     enableColumnActions: true,
//     manualFiltering: false,
//     manualPagination: true,
//     manualSorting: false,
//     rowCount,
//     onPaginationChange: setPagination,
//     onSortingChange: setSorting,
//     onGlobalFilterChange: setGlobalFilter,
//     onColumnFiltersChange: setColumnFilters,
//     mantineTableBodyCellProps: ({ row }) => ({
//       style: {
//         fontWeight: 500,
//         fontSize: "13px",
//         padding: "12px 16px",
//         borderBottom: "1px solid #f1f3f5",
//       },
//     }),
//     mantineTableHeadCellProps: {
//       style: {
//         backgroundColor: "#f8f9fa",
//         fontWeight: 600,
//         fontSize: "14px",
//         color: "#495057",
//         padding: "16px",
//         borderBottom: "2px solid #dee2e6",
//       },
//     },

//     state: {
//       columnFilters,
//       globalFilter,
//       isLoading,
//       pagination,
//       showProgressBars: isRefetching,
//       showSkeletons: isLoading,
//       sorting,
//       rowSelection,
//     },
//     mantinePaginationProps: {
//       showRowsPerPage: true,
//       withEdges: true,
//       radius: "md",
//       size: "md",
//       rowsPerPageOptions: ["20", "50", "100"],
//     },
//     paginationDisplayMode: "pages",
//     enableColumnPinning: true,
//     mantineTableProps: {
//       striped: true,
//       withRowBorders: true,
//       withColumnBorders: false,
//       style: {
//         borderRadius: "8px",
//         overflow: "hidden",
//       },
//     },
//   });
//   useEffect(() => {
//     const headerHeight = headerRef.current?.offsetHeight || 0;
//     const handleResize = () => {
//       // 190 là chiều cao của phần phân trang
//       // headerHeight là chiều cao của phần header
//       setHeight(window.innerHeight - (170 + headerHeight));
//     };

//     handleResize(); // Set initial height
//     window.addEventListener("resize", handleResize); // Update height on window resize

//     return () => {
//       window.removeEventListener("resize", handleResize); // Clean up event listener
//     };
//   }, []);

//   const fetchData = async () => {
//     setLoading(true);
//     setdata([]);
//     setError(undefined);
//     let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
//       pagination.pageSize
//     }`;
//     const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
//     try {
//       let urlSearch = `${API_ROUTE.GET_LIST_LINK_REDIRECT}${url}`;
//       if (!isNullOrEmpty(paramSearch?.keyWord))
//         urlSearch = urlSearch + `&KeySearch=` + paramSearch?.keyWord;
//       if (!isNullOrUndefined(paramSearch?.inActive))
//         urlSearch = urlSearch + `&Active=` + paramSearch?.inActive;
//       let callapi = await repository.get<MessageResponse<any[]>>(urlSearch);
//       if (isNullOrUndefined(callapi) || isNullOrUndefinedArry(callapi?.data)) {
//         setTotal(0);
//       } else {
//         // console.log("callapi", callapi);
//         setdata(callapi?.data ?? []);
//         setRowCount(callapi?.totalCount ?? 0);
//       }
//       return callapi?.data;
//     } catch (error: any) {
//       setError("Có lỗi xảy ra khi tải dữ liệu !");
//       return null;
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, [pagination]);

//   const onChangeText = (event: React.ChangeEvent<HTMLInputElement>) => {
//     const key = event?.target?.value;
//     if (!isNullOrUndefined(key))
//       setParamSearch({ ...paramSearch, keyWord: key });
//   };

//   const openModal = () =>
//     modals.openConfirmModal({
//       title: (
//         <>
//           <div color="white">
//             <Title order={5}>Thêm mới Tag</Title>
//           </div>
//         </>
//       ),
//       children: (
//         <CreateView
//           onSearch={() => fetchData()}
//           onClose={handleDeleteViewClose}
//           load={deleteViewStatus}
//         />
//       ),
//       confirmProps: { display: "none" },
//       cancelProps: { display: "none" },
//     });

//   const openModalEdit = () => {
//     if (
//       isSelectedItem &&
//       (isSelectedItem.length < 1 || isSelectedItem.length > 1)
//     )
//       NotificationExtension.Warn("Xin vui lòng chọn 1 sản phẩm để chỉnh sửa !");
//     else {
//       editItem(isSelectedItem[0].id);
//     }
//   };

//   const openModalDelete = () => {
//     // Lấy các ID của row được chọn
//     const selectedIds = Object.keys(rowSelection)
//       .filter((key) => rowSelection[key])
//       .map((key) => data[parseInt(key)].id);
//     if (selectedIds.length === 0) {
//       NotificationExtension.Warn("Xin vui lòng chọn dữ liệu để xóa!");
//       return;
//     } else {
//       const ids = selectedIds;
//       deleteItem(ids);
//     }
//   };

//   function deleteItem(idItem: number[]) {
//     modals.openConfirmModal({
//       title: (
//         <>
//           <Title order={5}>Xoá Tag</Title>
//         </>
//       ),
//       children: (
//         <DeleteView
//           onSearch={() => fetchData()}
//           idItem={idItem}
//           setRowSelection={setRowSelection}
//         />
//       ),
//       confirmProps: { display: "none" },
//       cancelProps: { display: "none" },
//     });
//   }

//   function editItem(id: number) {
//     modals.openConfirmModal({
//       title: (
//         <>
//           <Title order={5}>Chỉnh sửa Tag</Title>
//         </>
//       ),

//       children: (
//         <EditView
//           id={id}
//           onClose={handleDeleteViewClose}
//           onSearch={() => fetchData()}
//         />
//       ),
//       confirmProps: { display: "none" },
//       cancelProps: { display: "none" },
//     });
//   }

//   const [isFrist, setIsFrist] = useState(true);
//   return (
//     <Stack gap="xl" style={{ padding: "20px", minHeight: "100vh" }}>
//       {/* Header Section */}
//       <Card shadow="md" p="xl" radius="lg" withBorder>
//         <Stack gap="lg">
//           <Group justify="space-between" align="center">
//             <Group gap="md" align="center">
//               <IconSearch size={28} color="#228be6" />
//               <Title order={2} c="blue" size="24px">
//                 Quản lý chuyển hướng URL
//               </Title>
//             </Group>
//           </Group>

//           <Group justify="space-between" align="center" wrap="nowrap">
//             <Group gap="md" style={{ flex: 1, maxWidth: "600px" }}>
//               <TextInput
//                 size="md"
//                 placeholder="Nhập từ khóa tìm kiếm..."
//                 type="text"
//                 style={{ flex: 1 }}
//                 onChange={onChangeText}
//                 leftSection={<IconSearch size={18} color="#15aabf" />}
//                 onKeyDown={(e) => {
//                   if (e.key === "Enter") {
//                     fetchData();
//                   }
//                 }}
//                 radius="md"
//               />
//               <Button
//                 type="submit"
//                 leftSection={<IconSearch size={18} />}
//                 color="blue"
//                 size="md"
//                 variant="filled"
//                 onClick={async () => {
//                   await fetchData();
//                 }}
//                 radius="md"
//               >
//                 Tìm kiếm
//               </Button>
//             </Group>

//             <AppAction
//               openModal={openModal}
//               openModalDelete={openModalDelete}
//               openModalEdit={openModalEdit}
//             />
//           </Group>
//         </Stack>
//       </Card>

//       {/* Table Section */}
//       <Card shadow="md" p="lg" radius="lg" withBorder style={{ flex: 1 }}>
//         <MantineReactTable table={table} />
//       </Card>
//     </Stack>
//   );
// };

// export default UrlRedirect;

import {
  ActionIcon,
  Anchor,
  Badge,
  Box,
  Button,
  Grid,
  Group,
  Input,
  Select,
  Title,
  Tooltip,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { modals } from "@mantine/modals";
import {
  IconEdit,
  IconLink,
  IconPlus,
  IconSearch,
  IconTrash,
} from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import BreadCrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import Repository from "../../../_base/helper/HttpHelper";
import AppAction from "../../../common/AppAction";
import { _localization } from "../../../config/location";
import { API_ROUTE } from "../../../const/apiRoute";
import ModalUpdateExcelProduct from "../../ProductManager/ProductList/ModalUpdate/ModalUpdateExcelProduct";
import CreateView from "./CreateView";
import DeleteView from "./DeleteView";
import EditView from "./EditView";
interface SearchCriteria {
  keySearch?: string;
  status?: string;
  location?: string;
  HasNewUrl?: string;
}

const UrlRedirect = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [data, setData] = useState<any[]>([]);
  const [rowCount, setRowCount] = useState(0);
  const [deleteViewStatus, setDeleteViewStatus] = useState(0);
  const hacomUrl = process.env.REACT_APP_BASE_WEB_HACOM_URL;
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const form = useForm<SearchCriteria>({
    mode: "uncontrolled",
    initialValues: {
      keySearch: _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
      HasNewUrl: _searchJson && checkedPinSearch ? _searchJson?.HasNewUrl : "",
    },
  });

  const styleTableMantine = {
    fontWeight: "500",
  };
  const handleDeleteViewClose = (status: number) => {
    setDeleteViewStatus(status);
  };

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "STT",
        header: "STT",
        size: 80,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => <>{row.index + 1}</>,
      },
      {
        accessorKey: "oldUrl",
        header: "Link truy cập",
        size: 400,
      },
      {
        header: "Xem tại web",
        size: 150,
        Cell: ({ renderedCellValue, row }) => {
          const oldUrl = row.original.oldUrl;
          const isFullUrl =
            oldUrl &&
            (oldUrl.startsWith("http://") || oldUrl.startsWith("https://"));
          const finalUrl = isFullUrl ? oldUrl : `${hacomUrl}${oldUrl}`;

          return (
            <Group>
              <Anchor
                href={finalUrl}
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                fw={500}
                c="blue"
              >
                Xem web
              </Anchor>
            </Group>
          );
        },
      },
      {
        accessorKey: "newUrl",
        header: "Link đích",
        size: 400,
      },
      {
        accessorKey: "redirectCode",
        header: "Redirect code",
        Cell: ({ renderedCellValue, row }) => (
          <Badge
            color={
              renderedCellValue === "301"
                ? "blue"
                : renderedCellValue === "302"
                ? "orange"
                : "gray"
            }
            variant="filled"
            radius="md"
            size="md"
          >
            {renderedCellValue}
          </Badge>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        size: 120,
        Cell: ({ renderedCellValue, row }) => (
          <Group gap="xs" justify="center">
            <Tooltip label="Chỉnh sửa" position="top">
              <ActionIcon
                variant="light"
                color="blue"
                size="md"
                radius="md"
                onClick={(e: any) => {
                  editItem(row.original.id);
                }}
              >
                <IconEdit size={16} />
              </ActionIcon>
            </Tooltip>{" "}
            <Tooltip label="Xóa" position="top">
              <ActionIcon
                variant="light"
                color="red"
                size="md"
                radius="md"
                onClick={(e: any) => {
                  deleteItem([row.original.id]);
                }}
              >
                <IconTrash size={16} />
              </ActionIcon>
            </Tooltip>
          </Group>
        ),
      },
    ],
    []
  );

  // Hàm lấy dữ liệu
  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);

    try {
      const search = form.getValues();

      const queryParams = new URLSearchParams();

      if (search && search.keySearch) {
        queryParams.append("KeySearch", search.keySearch);
      }

      if (search && search.HasNewUrl) {
        queryParams.append("HasNewUrl", search.HasNewUrl);
      }
      if (pagination) {
        queryParams.append(
          "Skip",
          String(pagination.pageIndex * pagination.pageSize)
        );
        queryParams.append("Take", String(pagination.pageSize));
      }

      const url = `${
        API_ROUTE.GET_LIST_LINK_REDIRECT
      }?${queryParams.toString()}`;
      const response = await repository.get(url);
      if (response) {
        let result = response.data;
        setData(result);
        setRowCount(response.totalCount);
        table.resetRowSelection();
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify(form.getValues())
      );
    }
  };
  const openModal = () =>
    modals.openConfirmModal({
      title: (
        <>
          <div color="white">
            <Title order={5}>Thêm mới Tag</Title>
          </div>
        </>
      ),
      children: (
        <CreateView
          onSearch={() => fetchData()}
          onClose={handleDeleteViewClose}
          load={deleteViewStatus}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      closeOnClickOutside: false,
      closeOnEscape: false,
      withCloseButton: false,
    });

  function deleteItem(idItem: number[]) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Xoá Tag</Title>
        </>
      ),
      children: (
        <DeleteView
          onClose={setDeleteViewStatus}
          onSearch={() => fetchData()}
          idItem={idItem}
          setRowSelection={setRowSelection}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function editItem(id: number) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Chỉnh sửa Tag</Title>
        </>
      ),

      children: (
        <EditView
          id={id}
          onClose={handleDeleteViewClose}
          onSearch={() => fetchData()}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      closeOnClickOutside: false,
      closeOnEscape: false,
      withCloseButton: false,
    });
  }

  const table = useMantineReactTable({
    columns,
    data: data,
    enableColumnResizing: true,
    rowCount,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    // manualPagination: true,

    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    enableStickyFooter: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onPaginationChange: setPagination,
    positionToolbarAlertBanner: "bottom",
    initialState: {
      showColumnFilters: false,
      showGlobalFilter: true,
      columnPinning: {
        left: ["mrt-row-select"],
        right: ["status", "priority", "action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    enableRowSelection: true,
    onRowSelectionChange: setRowSelection,
    // mantineTableBodyCellProps: ({ row }) => ({
    //   style: styleTableMantine,
    // }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,

    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
      siblings: 1,
      boundaries: 1,
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });
  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (185 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);
  useEffect(() => {
    fetchData();
  }, [pagination]);

  // hàm mở modal để cập nhật file excel
  const openModalupdateExel = () => {
    modals.openConfirmModal({
      title: (
        <>
          <div color="white">
            <Title order={5}>Thêm link redirect qua Excel</Title>
          </div>
        </>
      ),
      children: <ModalUpdateExcelProduct location={location} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };
  return (
    <Box>
      <Group gap={0} justify="space-between" mb={10}>
        <BreadCrumb></BreadCrumb>
        <AppAction
          // openModal={openModal}
          // openModalDelete={openModalDelete}
          // openModalEdit={openModalEdit}
          // isUpdateSearchItem={true}
          openModalupdateExel={openModalupdateExel}
          // exportExcel={exportExcel}
        ></AppAction>
      </Group>
      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        <Box style={{ display: "flex", justifyContent: "space-between" }}>
          <Grid mt={10}>
            <Grid.Col
              style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}
            >
              <Input
                placeholder="Nhập tìm kiếm"
                key={form.key("keySearch")}
                type="text"
                leftSection={<IconSearch size={"20"} color="#15aabf" />}
                onKeyDown={async (e) => {
                  if (e.key === "Enter") {
                    await fetchData();
                  }
                }}
                {...form.getInputProps("keySearch")}
              />
              <Select
                placeholder="Link đích"
                key={form.key("HasNewUrl")}
                data={[
                  { label: "Có link đích", value: "true" },
                  { label: "Không có link đích", value: "false" },
                ]}
                leftSection={<IconLink size={"20"} color="#15aabf" />}
                clearable
                {...form.getInputProps("HasNewUrl")}
              />
              <Button
                color="blue"
                variant="outline"
                onClick={async () => {
                  await fetchData();
                }}
              >
                Tìm kiếm
              </Button>
            </Grid.Col>
          </Grid>
          <Group>
            <Button
              mt={10}
              leftSection={<IconPlus size={14} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                openModal();
              }}
            >
              Thêm mới
            </Button>
            <Button
              mt={10}
              mr={10}
              leftSection={<IconTrash size={14} />}
              color="red"
              variant="outline"
              onClick={async () => {
                const selectedIds = Object.keys(rowSelection).map(
                  (key) => data[Number(key)].id
                );
                if (selectedIds && selectedIds.length < 1) {
                  NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
                  return null;
                }
                await deleteItem(selectedIds);
              }}
            >
              Xóa (Đã chọn)
            </Button>
          </Group>
        </Box>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </Box>
  );
};

export default UrlRedirect;
